// extracted by mini-css-extract-plugin
export default {"sectionTxtContainer":"SectionComponent_sectionTxtContainer__EuTyJ","emailSection":"SectionComponent_emailSection__E91o+"};